// extracted by mini-css-extract-plugin
export default {"lazy":"lazy_O2gfl","show":"show_moazN"};